import { useSelector } from "react-redux";
import { createUseStyles } from "react-jss";
import { getUploadOneViewUrl } from "../../../../utils/urls";
import showImageSkin from "../../../../skins/show-image.skin";

const useStyles = createUseStyles(showImageSkin);

function InputUploadOneReadOnly({ value, className, id, fieldOptions }) {
  const showImagePreview = useSelector(
    (state) => state.configuration.showImagePreview
  );

  const classes = useStyles();

  const filenamePublicPath = value
    ? getUploadOneViewUrl({ fieldOptions, filename: value })
    : "";

  return (
    <span className={className} id={id}>
      {value ? (
        <a href={filenamePublicPath} target="_blank" rel="noreferrer">
          {showImagePreview && /(\.jpg|\.jpeg|\.png|\.gif)$/i.test(value) ? (
            <img
              src={filenamePublicPath}
              alt={value}
              className={classes["image-preview"]}
            />
          ) : (
            value
          )}
        </a>
      ) : (
        <>&nbsp;&nbsp;</>
      )}
    </span>
  );
}

export default InputUploadOneReadOnly;
